<template>
	<div class="FieldSelect">
		<BaseSelect v-model="field.value" :placeholder="field.label" :label="field.label" class="u-offset">
			<option v-for="option of field.options" :key="option.label" :value="option.value">{{ option.label }}</option>
		</BaseSelect>
	</div>
</template>

<script>
	export default {
		props: {
			field: Object
		}
	}
</script>